import script from "./EmployeeEmergencyContact.vue?vue&type=script&lang=ts&setup=true"
export * from "./EmployeeEmergencyContact.vue?vue&type=script&lang=ts&setup=true"

import "./EmployeeEmergencyContact.vue?vue&type=style&index=0&id=b78fa8ac&lang=scss"

const __exports__ = script;

export default __exports__